// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(
    <FluentProvider theme={webLightTheme}>
        <App />
    </FluentProvider>
);
